import type { CurrencyFormat, Strings } from '../types';

/** 1234.5 -> "$1,234.50" (prefix) or "1 234,50 €" (suffix). */
export function formatMoney(amount: number, c: CurrencyFormat): string {
  const negative = amount < 0;
  const abs = Math.abs(amount);
  const fixed = abs.toFixed(c.decimals);
  const [int, frac] = fixed.split('.');
  const thousands = c.position === 'prefix' ? ',' : ' ';
  const decimal = c.position === 'prefix' ? '.' : ',';
  const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
  const num = frac ? `${grouped}${decimal}${frac}` : grouped;
  const sign = negative ? '-' : '';
  return c.position === 'prefix' ? `${sign}${c.symbol}${num}` : `${sign}${num}${c.symbol ? ` ${c.symbol}` : ''}`;
}

/** Look up a string and interpolate {var} placeholders. Returns the key when missing. */
export function t(strings: Strings, key: string, vars?: Record<string, string | number>): string {
  let s = strings[key] ?? key;
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.split(`{${k}}`).join(String(v));
  return s;
}

/** Milliseconds -> "h:mm:ss". */
export function formatDuration(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}
